import { ADMIN_CENTER_DATA } from '@routes/sidebar/___shared___/api/constants.ts';

export const CREW_USERS_STEP_TITLE = 'crewUsers';

export const CREW_USERS_DATA_PAYLOAD = {
    dataToReturn: [
        ADMIN_CENTER_DATA.RANK_SETS_WITH_REFERENCE,
        ADMIN_CENTER_DATA.VESSELS,
        ADMIN_CENTER_DATA.SHORE_DEPARTMENT_TYPES,
        ADMIN_CENTER_DATA.SHORE_DEPARTMENTS,
        ADMIN_CENTER_DATA.SHORE_TEAMS,
        ADMIN_CENTER_DATA.COUNTRY,
    ],
};
